import { absolutePath } from "./absolutePath";

export const notificationPreferences = {
  index: () => absolutePath("notification_preferences"),
  update: () => absolutePath("notification_preferences"),
  unsubscribeAll: () =>
    absolutePath("notification_preferences/unsubscribe_all"),
};
